import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("input", {
    name: "id",
    type: "text",
    class: "w-full rounded-md"
  })
], -1)
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("input", {
    name: "name",
    type: "text",
    class: "w-full rounded-md"
  })
], -1)
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("input", {
    name: "adminUsername",
    type: "text",
    class: "w-full rounded-md"
  })
], -1)
const _hoisted_10 = { class: "py-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("input", {
    name: "userUsername",
    type: "text",
    class: "w-full rounded-md"
  })
], -1)
const _hoisted_12 = { class: "py-2" }
const _hoisted_13 = { class: "my-4 flex justify-center gap-8" }
const _hoisted_14 = { class: "flex-1 bg-blue-500 text-white p-1 px-4 rounded" }

import {useStore} from 'vuex'
import {onMounted, ref} from 'vue'
import {getTicketTopics, getTicketStatuses} from '@/utils/ticket-config'
import DialogComponent from '@/components/doalog/DialogComponent.vue'
import DropdownComponent from '@/components/tools/DropdownComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketAdvanceFilterDialog',
  props: {show: Boolean},
  emits: ['update:show', 'onSubmit'],
  setup(__props, { emit }) {



const store = useStore()

const form = ref()
const ticketTopicOptions = ref<{label: string; value: string}[]>()
const selectedTicketTopic = ref<{label: string; value: string}>({label: 'All', value: ''})
const ticketStatusOptions = ref<{label: string; value: string}[]>()
const selectedTicketStatus = ref<{label: string; value: string}>({label: 'All', value: ''})

const onSubmit = () => {
  const formData = new FormData(form.value)
  let payload: any = {
    ...(selectedTicketTopic.value.value ? {caseType: selectedTicketTopic.value.label} : {}),
    ...(selectedTicketStatus.value.value ? {status: selectedTicketStatus.value.value} : {}),
  }

  for (let [key, value] of formData.entries()) {
    if (value) payload[key] = value
  }
  emit('onSubmit', payload)
}

onMounted(() => {
  /** TODO: handler topic permissions */
  const ticketTopics = getTicketTopics(store.state.user)
  ticketTopicOptions.value = [{label: 'All', value: ''}, ...ticketTopics]
  const ticketStatuses = getTicketStatuses(store.state)
  ticketStatusOptions.value = [{label: 'All', value: ''}, ...ticketStatuses]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogComponent, {
    title: _ctx.$t('messages.ticketManagement.advanceFilter'),
    isOpen: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          ref_key: "form",
          ref: form,
          action: "",
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.ticketTopic')) + " ", 1),
            _createVNode(DropdownComponent, {
              class: "w-full",
              options: ticketTopicOptions.value,
              modelValue: selectedTicketTopic.value,
              onOnOptionSelected: _cache[0] || (_cache[0] = (option) => (selectedTicketTopic.value = option))
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.ticketId')) + " ", 1),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.ticketName')) + " ", 1),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.ticketOwner')) + " ", 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.userUsername')) + " ", 1),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.status')) + " ", 1),
            _createVNode(DropdownComponent, {
              class: "w-full",
              options: ticketStatusOptions.value,
              modelValue: selectedTicketStatus.value,
              onOnOptionSelected: _cache[1] || (_cache[1] = (option) => (selectedTicketStatus.value = option))
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "button",
              class: "flex-1 bg-red-500 text-white p-1 px-4 rounded",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:show', false)))
            }, _toDisplayString(_ctx.$t('messages.ticketManagement.cancel')), 1),
            _createElementVNode("button", _hoisted_14, _toDisplayString(_ctx.$t('messages.ticketManagement.filter')), 1)
          ])
        ], 40, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["title", "isOpen"]))
}
}

})